// Shared client-side validation. All NeuralOps accounts use @wissen.com emails.
export const WISSEN_EMAIL = /^[a-z0-9._%+-]+@wissen\.com$/i;

export function isWissenEmail(email) {
  return typeof email === 'string' && WISSEN_EMAIL.test(email.trim());
}

// Returns an error string for an email field, or '' if valid.
export function emailError(email) {
  if (!email?.trim()) return 'Email is required';
  if (!isWissenEmail(email)) return 'Use your @wissen.com email address';
  return '';
}
